import {
  ITennisResults
} from "@sky-it-livedata/livedata-sports-design-system";
import { isNotEmptyArray } from "@sky-it-livedata-libraries/livedata-commons";
import { ResultsData } from "../types";
import { composeEmptyPlayers } from "../results-utils";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { CreateResultsWidgetInputSchema } from "cdk/graphql";
import { isValidResults } from "./typeguards";

export const transformQuery = (obj: ResultsData): ITennisResults => {
  if (isValidResults(obj)) {
      CreateResultsWidgetInputSchema().parse(obj.data.getResultsWidget, {reportInput: true});
      const { matches, categoryName, date } = obj?.data?.getResultsWidget;

      return {
        categoryName,
        date,
        matches: matches?.map((match) => {
          return {
            ...match,
            firstPosition: {
              ...match?.firstPosition,
              players: isNotEmptyArray(match?.firstPosition?.players) ? match?.firstPosition?.players : composeEmptyPlayers(categoryName!),
            },
            secondPosition: {
              ...match?.secondPosition,
              players: isNotEmptyArray(match?.secondPosition?.players) ? match?.secondPosition?.players : composeEmptyPlayers(categoryName!),
            },
          }
        })
      } as ITennisResults;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in ResultsQuery object',
      data: obj
    });
  }
};